module.exports = __webpack_public_path__ + "f3af6018f4e315dfe15ea3013c4fd9d3.pdf";